import RiskScore from './risk-score';
import Velocity from './velocity';
import IpAddress from './ip-address';
import AVSCode from './avs-code';
import AVSMessage from './avs-message';
import CVVCode from './cvv-code';
import CVVMessage from './cvv-message';
import IsHosting from './is-hosting';
import IsProxy from './is-proxy';
import IsTor from './is-tor';
import IsVPN from './is-vpn';
import BillingAddress from './billing-address';
import PaymentCard from './payment-card';

/**
 * Risks parsed from model
 * @type {array}
 */
const defaultRisks = [
    RiskScore,
    Velocity,
];

/**
 * Risks parsed from RiskMetadata
 * @type {array}
 */
const metadataRisks = [
    IpAddress,
    IsHosting,
    IsProxy,
    IsTor,
    IsVPN,
];

/**
 * Risks parsed from gateway
 * @type {Array}
 */
const gatewayRisks = [
    AVSCode,
    AVSMessage,
    CVVCode,
    CVVMessage,
];


/**
 * Risks parsed from riskMetadata and billingAddress
 * @type {array}
 */
const billingAddressRisks = [
    BillingAddress,
];

/**
 * Risks parsed from paymentInstrument and billingAddress
 * @type {PaymentCard[]}
 */
const paymentInstrumentRisks = [
    PaymentCard,
];

/**
 * Make risks list, returns only isAvailable risks
 *
 * @param {array} list - defaultRisks|metadataRisks|gatewayRisks
 * @param {object} data - risk data
 * @returns {array}
 */
const getRisks = (list, data) => {
    if (!data) {
        return [];
    }
    return list.map(
        RiskClass => new RiskClass(data),
    ).filter(risk => risk.isAvailable());
};

/**
 * Returns default risks list
 * @param {object} model
 * @returns {array}
 */
export const getDefaultRisks = model => getRisks(defaultRisks, model);

/**
 * Returns riskMetadata
 * @param {object} riskMetadata
 * @returns {array}
 */
export const getMetadataRisks = riskMetadata => getRisks(metadataRisks, riskMetadata);

/**
 * Returns gateway risks
 * @param {object} gateway
 * @returns {array}
 */
export const getGatewayRisks = gateway => getRisks(gatewayRisks, gateway);

/**
 * Returns billing address risks
 *
 * @param {object} riskMetadata
 * @param {object} billingAddress
 * @returns {Array}
 */
export const getBillingAddressRisks = (
    {riskMetadata, billingAddress},
) => getRisks(billingAddressRisks, {
    riskMetadata,
    billingAddress,
});

/**
 * Returns payment instrument risks
 *
 * @param {object} riskMetadata
 * @param {object} billingAddress
 * @returns {Array}
 */
export const getPaymentInstrumentRisks = (
    {paymentInstrument, billingAddress, paymentCard},
) => getRisks(paymentInstrumentRisks, {
    paymentInstrument,
    billingAddress,
    paymentCard,
});
